class EditPoint {

}

export default EditPoint;